import { FC, RefObject } from 'react';
import { FONT_COLOURS } from '@belong/themes';
import { Copy } from '@belong/ui-components';
import { LinkWrapper } from '../styles';
import { IGHLargeLinkProps } from './GHMobileLink.types';
import * as styles from './styles';

const getColour = ({
  href,
  onClick,
  'aria-current': ariaCurrent
}: Pick<IGHLargeLinkProps, 'href' | 'onClick' | 'aria-current'>) => {
  const isLink = !!href || !!onClick;
  if (!isLink) {
    return FONT_COLOURS.DISABLED;
  }

  if (ariaCurrent) {
    return FONT_COLOURS.ACTIVE;
  }

  return FONT_COLOURS.LIGHT;
};

export const GHMobileLink: FC<IGHLargeLinkProps> = ({
  'aria-current': ariaCurrent,
  'aria-label': ariaLabel,
  href,
  iconName,
  iconRight = false,
  label,
  onClick,
  onKeyDown,
  linkRef,
  overrideColor,
  ...wrapperProps
}: IGHLargeLinkProps) => {
  const colour = getColour({ 'aria-current': ariaCurrent, href, onClick });

  if (href) {
    return (
      <LinkWrapper>
        <styles.Link
          href={href}
          aria-current={ariaCurrent}
          onClick={onClick}
          onKeyDown={evt => onKeyDown?.(evt)}
          {...wrapperProps}
        >
          {iconName && <styles.StyledIcon name={iconName} hasColor={overrideColor ?? colour} iconRight={iconRight} />}
          <styles.Copy
            hasColor={overrideColor ?? colour}
            as="span"
            {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
            isBold={Boolean(ariaCurrent)}
          >
            {label}
          </styles.Copy>
        </styles.Link>
      </LinkWrapper>
    );
  }

  return (
    <LinkWrapper>
      <styles.StyledButton
        onClick={() => {
          onClick?.();
        }}
        aria-current={ariaCurrent}
        ref={linkRef as unknown as RefObject<HTMLButtonElement>}
        secondLevelLink={!!wrapperProps.secondLevelLink}
        {...wrapperProps}
      >
        {iconName && <styles.StyledIcon name={iconName} hasColor={overrideColor ?? colour} iconRight={iconRight} />}
        <Copy hasColor={overrideColor ?? colour} as="span">
          {label}
        </Copy>
      </styles.StyledButton>
    </LinkWrapper>
  );
};

GHMobileLink.displayName = 'GHMobileLink';
